export default "/images/vendor/flag-icon-css/flags/1x1/tj.svg?9749373197a14f802651677b7b6bce90";